import React from "react";
import { Link } from "react-router-dom";
import { Truck, Package, Zap, Globe2, Box, Layers, Snowflake, Warehouse, Network, ArrowRight, ClipboardList, Send, Sparkles, Ship } from "lucide-react";

const SERVICES = [
  { icon: Sparkles, title: "White Glove Service", desc: "Our specialty. Precision handling for high-value, sensitive, and complex freight — inside delivery, unpacking, assembly, and debris removal. Concierge-grade service by trained crews." },
  { icon: Ship, title: "Drayage", desc: "Container drayage from Port of Vancouver and inland terminals to warehouse or DC. FCL, LCL, and transloading with bonded carriers and chassis pool access." },
  { icon: Truck, title: "Full Truckload (FTL)", desc: "Dedicated 53' trailer capacity for full-load shipments. Includes dry van, temperature-controlled (reefer), and expedited team-driver options — direct pickup-to-delivery with no consolidation." },
  { icon: Package, title: "Less Than Truckload (LTL)", desc: "Cost-effective shared capacity across dry van, refrigerated, and expedited service tiers. Reliable transit times, NMFC-compliant billing, and terminal-to-terminal visibility." },
  { icon: Globe2, title: "Cross-Border Shipping", desc: "Seamless US ↔ Canada ↔ Mexico moves. In-house customs, ACE/ACI filings, bonded carriers." },
  { icon: Layers, title: "Flatbed", desc: "Building materials, steel, oversized machinery. Step-decks, RGN, and specialized permits handled." },
  { icon: Warehouse, title: "Warehousing", desc: "3PL warehousing, cross-docking, pick-and-pack, and fulfillment across strategic North American nodes." },
  { icon: Network, title: "Supply Chain Solutions", desc: "Managed transportation, network design, procurement, and TMS integration for enterprise shippers." },
];

export default function Services() {
  return (
    <div>
      <section className="bg-[#0B3D6E] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="font-label text-xs text-[#2E7BC7]">Services</div>
          <h1 className="mt-3 font-display font-black text-4xl md:text-6xl">Full-service freight, one accountable partner.</h1>
          <p className="mt-5 text-slate-300 max-w-2xl">Specialists in <span className="text-white font-semibold">white glove service</span>. From concierge-grade deliveries to enterprise managed transportation — Apex covers every mode and every mile across North America.</p>
        </div>
      </section>
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map(({ icon: Icon, title, desc }, i) => {
            const slug = title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
            return (
              <div key={title} className="border border-gray-200 rounded-lg p-7 hover:border-[#2E7BC7]/40 hover:-translate-y-1 transition-all flex flex-col" data-testid={`service-detail-${i}`}>
                <div className="h-11 w-11 rounded-md bg-[#0B3D6E] flex items-center justify-center">
                  <Icon className="h-5 w-5 text-[#2E7BC7]" />
                </div>
                <h3 className="mt-5 font-display font-bold text-xl text-[#0B3D6E]">{title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed flex-1">{desc}</p>
                <div className="mt-6 grid grid-cols-2 gap-2">
                  <Link to={`/book?service=${encodeURIComponent(title)}`} className="btn-primary-apex text-sm inline-flex items-center justify-center gap-1.5" data-testid={`service-book-${slug}`}>
                    <ClipboardList className="h-4 w-4" /> Book Load
                  </Link>
                  <Link to={`/quote?service=${encodeURIComponent(title)}`} className="btn-secondary-apex text-sm inline-flex items-center justify-center gap-1.5" data-testid={`service-quote-${slug}`}>
                    <Send className="h-4 w-4" /> Ask Quote
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
